var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LoadFileDetail',{attrs:{"detail":_vm.detail,"completed":_vm.completed},on:{"saveFile":_vm.saveFile}})
}
var staticRenderFns = []

export { render, staticRenderFns }